module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Clock-23e55a0e9de6f3ffe8cd786f8662d625.svg";